'use client'

import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useAuthContext } from '@/context/AuthContext'
import { getWorldsDomain } from '@/lib/configs'
import { useTranslations } from 'next-intl'
import { usePathname } from 'next/navigation'

type SignInConfirmModalProps = {
  open?: boolean
  onClose?: () => void
}

export default function SignInConfirmModal({
  open = false,
  onClose = () => {},
}: SignInConfirmModalProps) {
  const t = useTranslations()
  const pathname = usePathname()
  const worldsDomain = getWorldsDomain()
  const { handleLogin } = useAuthContext()

  const handleAction = () => {
    handleLogin({ callback: `https://${worldsDomain}${pathname}` })
    onClose()
  }

  return (
    <DefaultAlertDialog
      open={open}
      type="custom"
      title={t('sign-in-confirm-modal.title')}
      description={t('sign-in-confirm-modal.description')}
      cancelText={t('sign-in-confirm-modal.cancel')}
      actionText={t('sign-in-confirm-modal.action')}
      onCancel={onClose}
      onAction={handleAction}
      cancelButtonClassName="rounded-full px-5 py-3 border-[1.5px] border-vive-primary-20 text-vive-primary-20 buttonM-omni-styles hover:border-vive-primary-40 hover:text-vive-primary-40 active:text-vive-primary-60 active:border-vive-primary-60"
      actionButtonClassName="rounded-full px-5 py-3 text-white buttonM-omni-styles bg-[#f53232] hover:bg-[#d42a2a] active:bg-[#b32424] "
      allowOutsideInteraction={true}
    />
  )
}
